import { mapKeys } from 'lodash';
import type { NextApiRequest, NextApiResponse } from 'next';
import { LogEvent, LogFn, Logger } from 'pino';

type LogFnArgument = Parameters<LogFn>;

// will delete this once everything is converted to app router
interface NextResponseLike {
  status: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  json: any;
}

const logBrowserLog = (logger: Logger, logEvent: LogEvent): void => {
  const logArguments: LogFnArgument = [
    logEvent.messages.shift(),
    ...logEvent.messages,
  ];

  // re-construct child logger bindings
  if (logEvent.bindings.length > 0) {
    for (let i = 0; i < logEvent.bindings.length; i++) {
      const binding = mapKeys(logEvent.bindings[i], (_value, key) => {
        if (key === 'context') {
          return 'browser-context';
        }
        return key;
      });

      logger = logger.child(binding);
    }
  }

  if (logEvent.level?.label === 'trace' || logEvent.level?.value === 10) {
    logger.trace(...logArguments);
  } else if (
    logEvent.level?.label === 'debug' ||
    logEvent.level?.value === 20
  ) {
    logger.debug(...logArguments);
  } else if (logEvent.level?.label === 'info' || logEvent.level?.value === 30) {
    logger.info(...logArguments);
  } else if (logEvent.level?.label === 'warn' || logEvent.level?.value === 40) {
    logger.warn(...logArguments);
  } else if (
    logEvent.level?.label === 'error' ||
    logEvent.level?.value === 50
  ) {
    logger.error(...logArguments);
  } else if (
    logEvent.level?.label === 'fatal' ||
    logEvent.level?.value === 60
  ) {
    logger.fatal(...logArguments);
  } else {
    logger.info(...logArguments);
  }
};

// Browser log sink endpoint
export const logSink = (
  req: NextApiRequest,
  res: NextApiResponse,
  logger: Logger,
): void => {
  try {
    const body = JSON.parse(req.body);
    body.forEach((logEvent: LogEvent) => logBrowserLog(logger, logEvent));
  } catch (err) {
    logger.error({ err }, 'Browser log sink error');
  }
  res.status(200).json({});
};

// will convert this to use NextResponse once everything is converted to app router
export const logSinkAppRouter = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any,
  logger: Logger,
): NextResponseLike => {
  try {
    body.forEach((logEvent: LogEvent) => logBrowserLog(logger, logEvent));
  } catch (err) {
    logger.error({ err }, 'Browser log sink error');
    return { status: 500, json: {} };
  }
  return { status: 200, json: {} };
};
